var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54167 13.9583H4.55104L11.475 7.03438L10.4656 6.025L3.54167 12.949V13.9583ZM2.125 15.375V12.3646L11.475 3.03229C11.6167 2.90243 11.7732 2.80208 11.9446 2.73125C12.116 2.66042 12.296 2.625 12.4844 2.625C12.6728 2.625 12.8558 2.66042 13.0333 2.73125C13.2109 2.80208 13.3644 2.90833 13.4937 3.05L14.4677 4.04167C14.6094 4.17153 14.7128 4.325 14.778 4.50208C14.8431 4.67917 14.8755 4.85625 14.875 5.03333C14.875 5.22222 14.8427 5.40237 14.778 5.57379C14.7133 5.74521 14.6098 5.90151 14.4677 6.04271L5.13542 15.375H2.125ZM10.9615 6.53854L10.4656 6.025L11.475 7.03438L10.9615 6.53854Z",
    fill: "#5A189A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/edit-outline.d35a77b09b6fbb7208859a1be51ed36e.svg";
export { ForwardRef as ReactComponent };